import { default as checkoutPayment } from './payment';
import { default as travelPayment } from './travelPayment';

export const payment = {
  ...checkoutPayment,
  ...travelPayment,
};
